import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function LoadingSpinner() {
    return <div className="loading-spinner">
        <FontAwesomeIcon icon="spinner" spin/>
    </div>;
}
